export default __webpack_public_path__ + "static/media/MaskGroup279.26eb63a7.png";